var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHaidiAuditLogIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#haidiAuditLogIcon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3 0v6.75H0v3C0 11.025.975 12 2.25 12h7.5c1.275 0 2.25-.975 2.25-2.25V0H3Zm7.5 9.75c0 .45-.3.75-.75.75H4.5v-9h6v8.25Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9 3.75H6v1.5h3v-1.5ZM9 6.75H6v1.5h3v-1.5Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "haidiAuditLogIcon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h12v12H0z"
})))));
export default SvgHaidiAuditLogIcon;